import React, { Component } from "react";
import { Button, Card, Modal } from "react-bootstrap";
import { Checkbox } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import L from "leaflet";
import { MapContainer, TileLayer, LayersControl, GeoJSON } from "react-leaflet";
import hash from "object-hash";
import Axios from "../../redux/axiosHandlerGeo";
import GeoJsonLayer from "./GeoJsonLayer";
import kanchanpur from "../../geojson/kanchanpur.json";
import { infastructure } from "../../variable/global";
// import kanchanpur from "../../geojson/bedkot.json";
import "leaflet/dist/leaflet.css";
import { connect } from "react-redux";

class EmergencyContactModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			sections: [],
		};
	}
	componentDidMount() {
		let sections = [
			{
				title: "स्वास्थ चौकी",
				numbers: [
					{
						title: "खलंगा प्राथमिक स्वास्थ केन्द्र",
						value: "०८६४२००३२",
					},
					{
						title: "खैरा स्वास्थ चौकी",
						value: "९८५७८३३७९२",
					},
					{
						title: "धररमपानी स्वास्थ चौकी ",
						value: "९८४७८२९४४५",
					},
					{
						title: "सहरी स्वास्थ इकाई सराङ्गकोट",
						value: "९८४४९८९८८४",
					},
					{
						title: "चुजा  स्वास्थ चौकी",
						value: "९८५७८३८२०१",
					},
					{
						title: "सामुदायिक स्वास्थ इकाई निशुन टाकुरा",
						value: "९८६६९१४८६४",
					},
				],
			},
			{
				title: "एम्बुलेन्स सेवा प्रदायक संस्था",
				numbers: [
					{
						title: "खल प्यूठान",
						value: "९८४७९८६०९२",
					},
					{
						title: "खल प्यूठान",
						value: "९८६६९१२९७२",
					},
				],
			},
			{
				title: "प्रहरी सम्पर्क कार्यालय",
				numbers: [
					{
						title: "वडा नं १ मरन्ठाना प्रहरी चाैकी",
						value: "९८६८०३६८४९",
					},
					{
						title: "वडा नं १ चुजाठाटी प्रहरी चाैकी",
						value: "९८५७८३३४१६",
					},
					{
						title: "वडा नं ४ जिल्ला प्रहरी कार्यलय प्युठान",
						value: "०८६-४२००४९ ,९८५७८९००८० ,१००",
					},
					{
						title: "जिल्ला प्रशासन कार्यालय प्युठान",
						value: "०८६-४२००४८",
					},
				],
			},
		];
		this.setState({ sections });
	}
	renderContacts() {
		return (
			<>
				{this.state.sections.map((section, secIndex) => {
					return (
						<div key={secIndex}>
							{section.title ? (
								<>
									<h3 className="font-weight-bolder mb-4 mt-4">
										{section.title}
									</h3>
								</>
							) : null}
							<div className="row">
								{section.numbers.map((number, numIndex) => {
									return (
										<div
											className="col-lg-6 d-flex flex-wrap mb-4"
											key={numIndex}
										>
											<h5 className="font-weight-bold mr-2">
												{number.title} :{" "}
											</h5>
											<h5 className="text-primary font-weight-bold">
												{number.value}
											</h5>
										</div>
									);
								})}
							</div>
						</div>
					);
				})}
			</>
		);
	}
	render() {
		return (
			<Modal
				{...this.props}
				size="xl"
				aria-labelledby="contained-modal-title-vcenter"
				centered
				closeButton
			>
				<Modal.Body className="p-md-15">
					<div className="d-flex justify-content-between mb-6">
						<h1 className="font-weight-bolder">
							<i className="icon-emergency text-primary display-4"></i> आपतकालीन
							सम्पर्क
						</h1>
						<i className="fa fa-times" onClick={this.props.onHide}></i>
					</div>
					{this.renderContacts()}
				</Modal.Body>
			</Modal>
		);
	}
}
class MunicipalityDescription extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalShow: false,
			boundData: [],
			wholeGeojson: [],
			location: {
				lat: 28.96725102178788,
				lng: 80.18087073179544,
			},
			zoom: 11,
			checkbox: {},
			wholeGeoJSON: {},
			showGeoJSON: [],
			sectionTitle: "",
		};
	}
	// 	this.getMunicpalId = this.getMunicpalId.bind(this);
	// }

	// isGeoJsonAlreadyFetched = (field) => {
	// 	const { wholeGeoJSON } = this.state;
	// 	return Boolean(wholeGeoJSON[field]);
	// };

	// fetchGeoJSON = (changedData) => {
	// 	const body = {
	// 		industries: "institute/industries",
	// 		cultural_heritage: "institute/cultural_heritage",
	// 		gov_office: "institute/gov_office",
	// 		forest: "institute/forest",
	// 		offices: "institute/offices",
	// 		infrastructure: "institute/infrastructure",
	// 		economic: "institute/economic",
	// 		education: "institute/education",
	// 		security: "institute/security",
	// 		palika_related_office: "institute/palika_related_office",
	// 		public_places: "institute/public_places",
	// 		health: "institute/health",
	// 	};

	// 	return new Promise((resolve, reject) => {
	// 		Axios.get(`/api/geojson/${body[changedData]}`)
	// 			.then((result) => {
	// 				const wholeGeoJSON = this.state.wholeGeoJSON;
	// 				this.setState(
	// 					{
	// 						wholeGeoJSON: {
	// 							...wholeGeoJSON,
	// 							[changedData]: result.data,
	// 						},
	// 					},
	// 					() => resolve()
	// 				);
	// 			})
	// 			.catch((err) => reject());
	// 	});
	// };

	// arrangeAllOption = async () => {
	// 	const { checkbox } = this.state;

	// 	const showGeoJSON = [];
	// 	let dataToCheck = [];

	// 	dataToCheck = dataToCheck.concat(infastructure);
	// 	const data = dataToCheck.map(async (each, i) => {
	// 		if (checkbox[each.value]) {
	// 			if (!this.isGeoJsonAlreadyFetched(each.value))
	// 				await this.fetchGeoJSON(each.value);

	// 			showGeoJSON.push(this.state.wholeGeoJSON[each.value]);
	// 		}
	// 	});
	// 	// wait until all promises resolve
	// 	await Promise.all(data);

	// 	this.setState({ showGeoJSON });
	// };

	// handleChange = (e) => {
	// 	e.persist();
	// 	this.setState(
	// 		({ checkbox }) => ({
	// 			checkbox: {
	// 				...checkbox,
	// 				[e.target.name]: e.target.checked,
	// 			},
	// 		}),
	// 		this.arrangeAllOption
	// 	);
	// };

	// style(feature) {
	// 	let skin = "blue";
	// 	if (feature.properties.FIRST_GaPa === "Bhimdatta") {
	// 		skin = "green";
	// 	}
	// 	return {
	// 		fillColor: skin,
	// 		weight: 1,
	// 		opacity: 1,
	// 		color: "black",
	// 		fillOpacity: 0.3,
	// 	};
	// }

	componentDidMount() {
		const boundData = [
			{
				key: "पुर्व",
				keyEnglish: "East",
				value: "अर्घाखाची जिल्ला",
				valueEnglish: "Arghakhachi District",
				class: "col-md-12",
				cStyle: 50,
			},
			{
				key: "उत्तर",
				keyEnglish: "North",
				value: "झिमरुक गाउँपालिका र प्यूठान नगरपालिका",
				valueEnglish: "Zhimruk rural municipality and Pyuthan municipality",
				class: "col-md-12",
				cStyle: 40,
			},
			{
				key: "पश्चिम",
				keyEnglish: "West",
				value: "माण्डवी गाउँपालिका र प्यूठान नगरपालिका",
				valueEnglish: "Mandvi rural municipality and Pyuthan municipality",
				class: "col-md-12",
				cStyle: 34,
			},
			{
				key: "दक्षिण",
				keyEnglish: "South",
				value: "ऐरावती गाउँपालिका",
				valueEnglish: "Airavati rural municipality",
				class: "col-md-12",
				cStyle: 35,
			},
			{
				key: "क्षेत्रफल",
				keyEnglish: "Area",
				value: "८०.०९ वर्ग कि.मि.",
				valueEnglish: "80.09 k.m",
				class: "col-md-12",
				cStyle: 20,
			},
			{
				key: "वडा संख्या",
				keyEnglish: "ward",
				value: "५",
				valueEnglish: "5",
				class: "col-md-12",
				cStyle: 5,
			},
			{
				key: "अक्षांश तथा देशान्तर",
				keyEnglish: "latitude and longitude",
				value: "२८.०९११११ , ८२.८८२५ ",
				valueEnglish: "“28.091111°N,82.8825°E”",
				class: "col-12",
				cStyle: 0,
			},
			// {
			// 	key: "मुख्य सहरी क्षेत्र",
			// 	keyEnglish: "Main city area",
			// 	value: "",
			// 	class: "col-12",
			// 	cStyle: 0,
			// },
		];
		this.setState({ ...this.state, boundData });
	}
	getMunicipalBounds() {
		let modalClose = () => this.setState({ modalShow: false });
		return (
			<div className="col-lg-5 pb-5 d-flex">
				<Card>
					<Card.Body>
						<div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/map_marker.svg")}
								alt=""
							/>
							<h2 className="font-weight-black pl-3 pt-6">
								{this.props.selectedLanguage == "nepali"
									? "सिमाना"
									: "Boundaries"}
							</h2>
						</div>
						<div className="row">
							{this.state.boundData.map((data, index) => {
								return (
									<div className={`pb-3 ${data.class}`} key={index}>
										<div className="d-flex">
											<h5 className="pr-2">
												{this.props.selectedLanguage == "nepali"
													? data.key
													: data.keyEnglish}
												:
											</h5>
											<h5
												className="text-primary"
												style={{ paddingLeft: data.cStyle }}
											>
												{this.props.selectedLanguage == "nepali"
													? data.value
													: data.valueEnglish}
											</h5>
										</div>
									</div>
								);
							})}
						</div>
						<div className="float-right ">
							<Button
								className="px-10 emergency-button"
								variant="light-danger"
								size="lg"
								onClick={() => this.setState({ modalShow: true })}
							>
								{" "}
								<i className="icon-emergency"></i>{" "}
								{this.props.selectedLanguage == "nepali"
									? "आपतकालीन सम्पर्क"
									: "Emergency Contact"}
							</Button>

							<EmergencyContactModal
								show={this.state.modalShow}
								onHide={modalClose}
							/>
						</div>
					</Card.Body>
				</Card>
			</div>
		);
	}
	getMunicpalId() {
		return (
			<div className="col-lg-7 pb-5 d-flex ">
				<Card>
					<Card.Body>
						<div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/municipality_id.svg")}
								alt=""
							/>
							<h2 className="font-weight-black pl-3 pt-6">
								{this.props.selectedLanguage == "nepali"
									? "गाउँपालिका अबस्थित  नक्शा"
									: "Rural Municipality Location Map"}
							</h2>
						</div>

						<img
							className="w-100"
							src={toAbsoluteUrl("/media/hamropalika/static-map.png")}
							alt=""
						/>
					</Card.Body>
				</Card>
			</div>
		);
	}
	render() {
		return (
			<>
				<div className="row">
					{this.getMunicpalId()}
					{this.getMunicipalBounds()}
				</div>
			</>
		);
	}
}

const mapStateToProps = (state) => ({
	selectedLanguage: state.ward.selectedLanguage,
});
export default connect(mapStateToProps)(MunicipalityDescription);
